const scrollTop = () => {
    const element = document.querySelector('.content-width');
    if (element) element.scrollTo(0, 0);
};

export default scrollTop;
